export default {
  STATUS: {
    NOT_PLANNED: 'not planned',
    PLANNED: 'planned',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
  },
}
